import * as React from 'react';
import UnpaidInvoices from './UnpaidInvoices';
import { Box, Grid } from '@mui/material';
import TypicaStockItemDelaySummaryPanel from './TypicaStockItemDelaySummaryPanel';
import RemainingWarehouseItemsPanel from './RemainingWarehouseItemsPanel';
var AdminDashboardPage = function () {
    return (React.createElement(Box, { p: 1 },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(UnpaidInvoices, null),
            React.createElement(TypicaStockItemDelaySummaryPanel, null),
            React.createElement(RemainingWarehouseItemsPanel, null))));
};
export default AdminDashboardPage;
